// @flow

import React from 'react';

import Topic from 'app/get-help/components/blocks/Topic/Topic';
import { base } from 'app/get-help/utils/tree';

import type { NodeDefinition } from 'app/get-help/utils/tree/types';
import { type NodeOptions } from 'app/get-help/components/blocks/Topic/types';

const topic = (options: NodeOptions): NodeDefinition => {
  const children = {};
  const items = [];

  options.items.forEach(({ child, ...item }) => {
    items.push(item);
    children[item.value] = child;
  });

  const node = base({
    id: 'topic',
    children,
    isDataValid: data => {
      return !!node.getNextNode(data, {});
    },
    getNextNode: data => {
      return typeof data === 'string' ? node.children[data] : null;
    },
    render: props => {
      return <Topic {...props} items={items} label={options.label} />;
    },
    export: data => ({
      id: node.id,
      data,
      label: options.label,
      zendeskCustomFieldId: options.zendeskCustomFieldId,
      zendeskCustomFieldValue:
        data &&
        (items.find(({ value }) => value === data) || {})
          .zendeskCustomFieldValue,
      formatted:
        data && (items.find(({ value }) => value === data) || {}).label,
    }),
  });

  return node;
};

export default topic;
